import { Col, Row } from "reactstrap";
import { H3, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const CommonUserHeader = () => {
  return (
    <Row>
      <Col sm="8">
        <div className="d-flex">
          <Image className="img-thumbnail rounded-circle me-3" src={dynamicImage("user/7.jpg")} alt="Generic placeholder img" />
          <div className="flex-grow-1 align-self-center">
            <H3 className="mt-0 user-name">JOHAN DIO</H3>
          </div>
        </div>
      </Col>
      <Col sm="4" className="align-self-center">
        <div className="float-sm-end">
          <small>10 Hours ago</small>
        </div>
      </Col>
    </Row>
  );
};
